import { TopClausesWrapper } from 'dsilo-ui-components';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { clearReduxDataOfCurrentComponent, getContractDataById, getDataModelById, getModelData } from '../../store/actions';
import { Loader } from "../loader";

const TopClausesComponent = (props) => {
	return (
		<div>
			<TopClausesWrapper loader={<Loader />} {...props} />
		</div>
	)
}

const mapDispatchToProps = {
    getContractDataById,
    getDataModelById,
	getModelData,
	clearReduxDataOfCurrentComponent,
};

const mapStateToProps = state => {
	return {
	  formData: state.form,	
	  user: state.user,
	};
  };
  
  export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TopClausesComponent));
  